"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadAndParseLibraries = exports.getLibrariesArtifactIds = void 0;
var manifest_1 = require("../manifest");
var RegistryError_1 = require("../errors/RegistryError");
function getLibrariesArtifactIds(libraries) {
    return libraries.map(function (library) {
        if (isLibraryManifest(library)) {
            return library.library.artifactId;
        }
        else if (isLibraryTopology(library)) {
            return library.artifactId;
        }
        else {
            return library.topology.artifactId;
        }
    });
}
exports.getLibrariesArtifactIds = getLibrariesArtifactIds;
/**
 * In case, when library is passed manually to registry,
 * to override some components urls
 */
var isLibrary = function (library) {
    return (library.hasOwnProperty('topology') && library.hasOwnProperty('components'));
};
/**
 * The default library configuration
 */
var isLibraryTopology = function (library) {
    return library.hasOwnProperty('artifactId') && library.hasOwnProperty('url');
};
/**
 * The parsed manifest, it is the result of `registry()` function call
 * it is used for SSR -> CSR optimization
 */
var isLibraryManifest = function (library) {
    return library.hasOwnProperty('hosts') && library.hasOwnProperty('library');
};
exports.loadAndParseLibraries = function (_a) {
    var transport = _a.transport, libraries = _a.libraries, libraryAssetsPatterns = _a.libraryAssetsPatterns, options = _a.options;
    return __awaiter(void 0, void 0, void 0, function () {
        var isCorrectLibraries, manifests, topologies, rawLibraries, parsedLibraries, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    isCorrectLibraries = libraries.every(function (library) {
                        return isLibraryManifest(library) ||
                            isLibraryTopology(library) ||
                            isLibrary(library);
                    });
                    if (!isCorrectLibraries) {
                        throw RegistryError_1.createException('invalid libraries').withHint('Probably wrong "libraries" argument was passed to the registry');
                    }
                    manifests = libraries.filter(function (library) {
                        return isLibraryManifest(library);
                    });
                    topologies = libraries.filter(function (library) {
                        return isLibraryTopology(library);
                    });
                    rawLibraries = libraries.filter(function (library) { return isLibrary(library); });
                    _b = [manifests];
                    return [4 /*yield*/, manifest_1.loadManifests(transport, topologies, options)];
                case 1:
                    parsedLibraries = __spreadArrays.apply(void 0, _b.concat([__spreadArrays.apply(void 0, [(_c.sent()), rawLibraries]).map(function (library) { return manifest_1.parseManifest(library, libraryAssetsPatterns); })]));
                    return [2 /*return*/, parsedLibraries];
            }
        });
    });
};
//# sourceMappingURL=loadAndParseLibraries.js.map